import React from "react";
import { formatCompact, formatPercent, percentClass } from "../utils/format";
import "./styles/GlobalStats.css";

/**
 * F1 — total market cap, 24h volume, BTC dominance, 24h global change.
 */
export default function GlobalStats({ global, currency, loading }) {
  if (loading && !global) {
    return (
      <div className="stats-bar" aria-busy="true">
        <div className="stat-skeleton" />
        <div className="stat-skeleton" />
        <div className="stat-skeleton" />
        <div className="stat-skeleton" />
      </div>
    );
  }
  if (!global) return null;

  const mcap = global.total_market_cap?.[currency];
  const vol = global.total_volume?.[currency];
  const btcDom = global.market_cap_percentage?.btc;
  const change = global.market_cap_change_percentage_24h_usd;

  const items = [
    { label: "Market Cap", value: mcap != null ? formatCompact(mcap, currency) : "—" },
    {
      label: "24h Volume",
      value: vol != null ? formatCompact(vol, currency) : "—",
    },
    {
      label: "BTC Dominance",
      value: btcDom != null ? `${btcDom.toFixed(1)}%` : "—",
    },
    {
      label: "24h Change",
      value: change != null ? formatPercent(change) : "—",
      className: percentClass(change),
    },
  ];

  return (
    <section className="stats-bar" aria-label="Global crypto market statistics">
      {items.map((it) => (
        <div className="stat" key={it.label}>
          <span className="stat-label">{it.label}</span>
          <span
            className={`stat-value mono ${it.className || ""}`}
            data-testid={`stat-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            {it.value}
          </span>
        </div>
      ))}
    </section>
  );
}
